import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import { faqs } from '../data/salesContent';
import { SectionShell } from './SectionShell';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <SectionShell eyebrow="Preguntas frecuentes" title="Resolvamos las dudas antes de decidir" className="border-y border-gold-500/10 bg-noir-900" data-id="element-67" data-mp="1gitwe5mpsyk9">
      <div className="mx-auto max-w-3xl space-y-2.5 sm:space-y-3" data-id="element-68" data-mp="28arug3ji962z">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <motion.div key={faq.question} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.45,
          delay: index * 0.05
        }} className={`overflow-hidden rounded-2xl border bg-noir-800/60 transition-colors ${isOpen ? 'border-gold-500/40' : 'border-cream/10 hover:border-cream/20'}`} data-id="element-69" data-mp="1uj4pzgfesr94" data-mpi={index}>
              <h3 data-id="element-70" data-mp="10vjm7xeusmzf">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gold-400 sm:gap-5 sm:px-7 sm:py-5" data-id="element-71" data-mp="10rvtv1l5a6ma">
                  <span className="font-display text-[15px] font-semibold text-cream sm:text-lg" data-id="element-72" data-mp="1xjfv0g41ue03">
                    {faq.question}
                  </span>
                  <motion.span animate={{
                rotate: isOpen ? 135 : 0
              }} transition={{
                duration: 0.3,
                ease: [0.22, 1, 0.36, 1]
              }} className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ring-1 ${isOpen ? 'bg-crimson-600/15 text-crimson-500 ring-crimson-500/40' : 'bg-noir-700 text-cream/60 ring-cream/10'}`} data-id="element-73" data-mp="35ose0k50ue5">
                    <Plus className="h-4 w-4" aria-hidden="true" data-id="element-74" data-mp="2c8mh6l4aj1b1" />
                  </motion.span>
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-75" data-mp="2h75yu9bupqxl">
                {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.32,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-76" data-mp="2m6adhfhjogvb">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-cream/65 sm:px-7 sm:pb-6 sm:text-[15px]" data-id="element-77" data-mp="2zwdrxka6n6a7">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>;
      })}
      </div>
    </SectionShell>;
}